/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Not_Found_TitleInputs */

const en_blog_not_found_title = /** @type {(inputs: Blog_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article not found`)
};

const lv_blog_not_found_title = /** @type {(inputs: Blog_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raksts nav atrasts`)
};

/**
* | output |
* | --- |
* | "Article not found" |
*
* @param {Blog_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_not_found_title = /** @type {((inputs?: Blog_Not_Found_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Not_Found_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_not_found_title(inputs)
	return en_blog_not_found_title(inputs)
});